import { Model } from 'app/model/backendmodel';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from './adapter-registry';
import { NamedAsyncAdapter } from './named-async.adapter';
import _ from 'lodash';
import { GlobalParametersARM } from '../globalparameters-arm/globalparameters-arm';
import { convertParameterValue } from 'app/shared/utils/parameter-converter.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GlobalParametersARM),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: '*'
    }
})
export class GlobalParametersARMAsyncAdapter extends NamedAsyncAdapter<GlobalParametersARM, Model.GlobalParametersARMResource> {
    protected async _toResource(globalParameters: GlobalParametersARM): Promise<Model.GlobalParametersARMResource> {
        const globalParametersResource = await super._toResource(globalParameters) as Model.GlobalParametersARMResource;
        globalParametersResource.properties = {};
        globalParameters.parameters.forEach((param) => {
            const parameterSpecification: Model.GlobalParameterSpecification = {
                type: param._type
            };
            if (param.defaultValue !== undefined) {
                const doNotParseValueIntoObject = param._type === 'securestring';
                parameterSpecification.value = 
                    param._type === 'securestring' && param.defaultValue === '' ? '' : convertParameterValue(param.defaultValue, param._type, 'GlobalParametersARMAsyncAdapter', this.ensureLogger(), doNotParseValueIntoObject);
            }
            globalParametersResource.properties[param.name] = parameterSpecification;
        });
        return globalParametersResource;
    }
}
